// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"5bc107f2","351":"cb31db5d","421":"bb6a85fe","443":"54d843db","542":"2c19513b","614":"31764423"}[chunkId] + ".chunk.js";
};